<i class="material-icons -medium -l-blue" [ngClass]="'non-clickable'" matTooltip="{{texto}}"
  aria-label="Button that displays a tooltip when focused or hovered over"
  matTooltipClass="tooltip-info">info</i>